export let SAVE_ADD_JOB_BUTTON = 'save_add_job_button';
export let CANCEL_ADD_JOB = 'cancel_add_job';
export let ADD_JOB_NOTES_INPUT = 'add_job_notes_input';
export let DEFECT_DETAILS_INPUT = 'defect_details_input';
export let ADD_WORKSHOP_JOB_DESCRIPTION = 'add_workshop_job_description';
export let WORKSHOP_JOB_TYPE_DROPDOWN = 'workshop_job_type_dropdown';
